export default "__VITE_ASSET__7b0fbf86__"